import { render } from "./StipendEligibility.vue?vue&type=template&id=028f6c70&ts=true"
import script from "./StipendEligibility.vue?vue&type=script&lang=ts"
export * from "./StipendEligibility.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__